<div class="page-not-found">
  <div class="container">
    <div class="error-content">
      <!-- 404 Number Display -->
      <div class="error-number">
        <span class="digit">4</span>
        <div class="zero-container">
          <div class="zero">0</div>
        </div>
        <span class="digit">4</span>
      </div>
      
      <!-- Error Message -->
      <h1 class="error-title">Page Not Found</h1>
      <p class="error-description">
        Oops! The page you're looking for doesn't exist. 
        It might have been moved, deleted, or you entered the wrong URL.
      </p>
      
      <!-- Action Buttons -->
      <div class="action-buttons">
        <button class="btn btn-primary" routerLink="/">
          <i class="icon-home"></i>
          Go Home
        </button>
        <button class="btn btn-secondary" (click)="goBack()">
          <i class="icon-arrow-left"></i>
          Go Back
        </button>
      </div>
      
      <!-- Helpful Links -->
      <div class="helpful-links">
        <p class="links-title">Or try these helpful links:</p>
        <div class="links-grid">
          <a href="#" class="link-item" routerLink="/landing">
            <i class="icon-dashboard"></i>
            <span>Dashboard</span>
          </a>
          <a href="#" class="link-item" routerLink="/demo/report">
            <i class="icon-chart"></i>
            <span>Reports</span>
          </a>
          <a href="#" class="link-item" routerLink="/landing/favourite-reports">
            <i class="icon-star"></i>
            <span>Favorites</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
